import { Loading } from 'framework/ui/mui-builder';
import SyberryTodayDashboard from './components/SyberryTodayDashboard/SyberryTodayDashboard';
import SyberryTodayPlanningFlow from './components/SyberryTodayPlanningFlow/SyberryTodayPlanningFlow';
import useSyberryTodayPageController from './useSyberryTodayPageController';
import useTaskStatusPingInterruptionDrawer from '../../availability/interruprions/create/taskStatusPing/useTaskStatusPingInterruptionDrawer';

const SyberryTodayPage = () => {
  const { isLoading, shouldShowDashboard, dashboard, planningFlow } = useSyberryTodayPageController();
  const { taskStatusPingInterruptionDrawer } = useTaskStatusPingInterruptionDrawer();

  const content = isLoading ? (
    <Loading isInitialPosition />
  ) : shouldShowDashboard ? (
    <SyberryTodayDashboard {...dashboard} />
  ) : (
    <SyberryTodayPlanningFlow planningFlow={planningFlow} />
  );

  return (
    <>
      {content}
      {taskStatusPingInterruptionDrawer}
    </>
  );
};

export default SyberryTodayPage;
